import { RadioBigField } from "../../Shared/Fields/RadioBigField";
import { Trans } from "../../utils/i18n";
import { useSyncUrlParam } from "./useSyncUrlParam";
import { useProductcategoriesQuery } from "../../hooks/queries/useProductcategoriesQuery";
import classNames from "classnames";

export function CategorySelector({
    values,
    form,
    showAll,
    name = "productcategory",
    queryOptions = {},
    onChange,
    columns = 2,
}) {
    const { data: productcategories, isLoading: isProductcategoriesLoading } =
        useProductcategoriesQuery({
            queryKey: [name],
            ...queryOptions,
        });
    useSyncUrlParam(
        "productcategory",
        (value) => {
            const productcategory = productcategories.find(
                (productCategory) => productCategory.name === value
            );
            if (productcategory) {
                form.change("productcategory", productcategory.id.toString());
            }
        },
        {
            enabled: !isProductcategoriesLoading && !!productcategories,
        }
    );

    if (isProductcategoriesLoading || !productcategories) {
        return null;
    }

    return (
        <div className="space-y-4">
            <h3 className="my-0">
                <Trans i18nKey={"shop.productcategorySelect"}>
                    What kind of device do you have?
                </Trans>
            </h3>

            <div className="grid grid-cols-12 gap-6">
                {productcategories.map((productcategory) => (
                    <RadioBigField
                        name={name}
                        key={productcategory.id}
                        value={productcategory.id.toString()}
                        onChange={(e) => {
                            onChange?.(e);
                            // TODO: We should remove this here!
                            form.change("model_group", null);
                            form.change("variant", null);
                        }}
                        className={classNames({
                            "col-span-6": true,
                            "md:col-span-3": columns === 4,
                            "md:col-span-4": columns === 3,
                        })}
                    >
                        {productcategory.image && (
                            <img className="mb-1 max-w-full object-contain h-[60px]" src={productcategory.image} alt={productcategory.description}/>
                        )}

                        {productcategory.description}
                    </RadioBigField>
                ))}

                {showAll && (
                    <RadioBigField
                        name={name}
                        value="all"
                        onChange={() => {
                            onChange?.(e);
                            // TODO: We should remove this here!
                            form.change("model_group", null);
                            form.change("variant", null);
                        }}
                        className={classNames({
                            "col-span-6": true,
                            "md:col-span-3": columns === 4,
                            "md:col-span-4": columns === 3,
                        })}
                    >
                        <Trans i18nKey="orderEntry.productcategory.showAll">
                            Show All
                        </Trans>
                    </RadioBigField>
                )}
            </div>
        </div>
    );
}
